import Vue from "vue";
import Router from "vue-router";
import WatchVideo from "@/components/Video/WatchVideo";
import VideoIndex from "@/components/Video/VideoIndex";
import News from "@/components/News/NewsIndex";
import Index from "@/components/Index";
import MoreProgram from "@/components/Video/MoreProgram";
import search from "@/components/Video/search";
import MoreMovie from "@/components/Video/MoreMovie";
import Feed from "@/components/Social/Feed";
import FeedHome from "@/components/Social/FeedHome";
import MyDynamicPic from "@/components/Social/MyDynamicPic";
import MyDynamic from "@/components/Social/MyDynamic";
import FeedCloud from "@/components/Social/FeedCloud";
import FeedPerson from "@/components/Social/FeedPerson";
import DisplayVideo from "@/components/Social/DisplayVideo";
import SocialVideoUpload from "@/components/Social/VideoUpload";
import Home from "@/components/Home";
import Backstage from "@/components/AdminManage/Backstage";
import programType from "@/components/AdminVideo/programType";
import AdminProgramList from "@/components/AdminVideo/AdminProgramList";
import VideoType from "@/components/AdminVideo/VideoType";
import HotWord from "@/components/AdminVideo/HotWord";
import uploadTV from "@/components/AdminVideo/uploadTV";
import TVList from "@/components/AdminVideo/TvList";
import VideoList from "@/components/AdminVideo/VideoList";
import FeatureList from "@/components/AdminVideo/FeatureList";
import EditProgram from "@/components/AdminVideo/EditProgram";
//用戶角色
import rolePermissions from "@/components/AdminUser/rolePermissions";
import roleList from "@/components/AdminUser/roleList";
import roleMenuList from "@/components/AdminUser/roleMenu";
import userList from "@/components/AdminUser/userList";
import login from "@/components/login/login";
//用户登录
import customerLogin from "@/components/Customer/customerLogin";
import forgotPassword from "@/components/Customer/forgotPassword";
import resetPassword from "@/components/Customer/resetPassword";
import resetPwSuccess from "@/components/Customer/resetPwSuccess";
import customerRegist from "@/components/Customer/customerRegist";
import registerEmail from "@/components/Customer/registerEmail";
import registerSuccess from "@/components/Customer/registerSuccess";
import customerPublish from "@/components/Customer/customerPublish";
import customerPublishLook from "@/components/Customer/customerPublishLook";
import customerFavorite from "@/components/Customer/customerFavorite";
import customerMessage from "@/components/Customer/customerMessage";
import customerInfo from "@/components/Customer/customerInfo";
import customerPrivateMessage from "@/components/Customer/customerPrivateMessage";

//话题前端
import articleList from "@/components/Topic/articleList";
import articleview from "@/components/Topic/articleview";
//活動前端
import ActiveList from "@/components/Activitys/ActiveList";
import Activeview from "@/components/Activitys/Activeview";
import SendMessage from "@/components/Activitys/SendMessage";
//話題管理员后台
import TopicList from "@/components/AdminTopic/TopicList";
import articleAdd from "@/components/AdminTopic/articleAdd";
import TopicRecommend from "@/components/AdminTopic/TopicRecommend";
import TopicTypeList from "@/components/AdminTopic/TopicTypeList";
import TopicReprint from "@/components/AdminTopic/TopicReprint";
import adminReport from "@/components/AdminReport/adminReport";
//活動管理員後臺
import EventList from "@/components/AdminEvent/EventList";
import EventType from "@/components/AdminEvent/EventType";
import EventCity from "@/components/AdminEvent/EventCity";
import EventArea from "@/components/AdminEvent/EventArea";
import EventStatus from "@/components/AdminEvent/EventStatus";
import EventRemark from "@/components/AdminEvent/EventRemark";
import EventAdd from "@/components/AdminEvent/EventAdd";
//相册
import albumIndex from "@/components/Album/albumIndex";
import albumList from "@/components/Album/albumList";
import albumviewDetail from "@/components/Album/albumviewDetail";
import albumviewPhotostream from "@/components/Album/albumviewPhotostream";

import albumviewPhoto from "@/components/Album/albumviewPhoto";

import albumviewFaceRecognition from "@/components/Album/albumviewFaceRecognition";
import collection from "@/components/Album/collection";
import collectionlist from "@/components/Album/collectionlist";
import VRanking from "@/components/Album/VRanking";
import photoview from "@/components/Album/photoview";

import uploadImage from "@/components/Album/uploadImage";
import AdminalbumList from "@/components/AdminAlbum/AdminalbumList";
import AdminImgDeal from "@/components/AdminAlbum/AdminImgDeal";
import albumCategory from "@/components/AdminAlbum/albumCategory";
import AlbumFeature from "@/components/AdminAlbum/AlbumFeature";
import AdminCollection from "@/components/AdminAlbum/Collection";
import AdminCollectionEdit from "@/components/AdminAlbum/CollectionEdit";
import PhotoFeature from "@/components/AdminAlbum/PhotoFeature";
//主页
import banner from "@/components/AdminBanner/BannerList";
import CreateBanner from "@/components/AdminBanner/CreateBanner";

import adminSocia from "@/components/AdminSocial/socialList";
import adminSociaGroup from "@/components/AdminSocial/group";
import adminSociaCloseGroup from "@/components/AdminSocial/closeGroup";
import adminVideoList from "@/components/AdminSocial/VideoList";

//留言
import comments from "@/components/AdminComment/comment";
//footer
import about from "@/components/common/about";
import contact from "@/components/common/contact";
import service from "@/components/common/service";
import privacy from "@/components/common/privacy";
import copyright from "@/components/common/copyright";
import advertise from "@/components/common/advertise";
import cooperate from "@/components/common/cooperate";
import comment from "@/components/common/comment";
import commentsucces from "@/components/common/commentsucces";
import eventsucces from "@/components/common/eventsucces";
//维护
import maintain from "@/components/common/maintain.vue";
//实名认证页面
import certification from "@/components/login/certification";
import certificationFlow from "@/components/login/certificationFlow";
import certificationTerms from "@/components/login/certificationTerms";
import certificationTermsIframe from "@/components/login/certificationTermsIframe";

//广告
import AdVertiserList from "@/components/AdminAd/AdVertiserList";
import AdList from "@/components/AdminAd/AdList";

import adminIndex from "@/components/AdminManage/index";
import adminHangfire from "@/components/AdminManage/hangfire";
import adminLog from "@/components/AdminLog/adminLog";
import userLog from "@/components/AdminLog/userLog";
import adminParentFooter from "@/components/AdminFooter/parent";
import adminpageFooter from "@/components/AdminFooter/page";
import adminchildFooter from "@/components/AdminFooter/child";
import adminchildFooterEdit from "@/components/AdminFooter/pageEdit";
import sortLink from "@/components/common/sortLink";
import initFoot from "@/components/common/initFoot";
import adminDefaultIndex from "@/components/AdminManage/defaultIndex";

import blogIndex from "@/components/blog/index";
import blogAll from "@/components/blog/all";
import blogCategory from "@/components/blog/category";
import blogContent from "@/components/blog/content";
import blogUserInfo from "@/components/blog/userInfo";
import adminBlogIndex from "@/components/AdminBlog/index";

import FeedGroup from "@/components/Social/group/index";
import Feedfriend from "@/components/Social/friend/index";
import FeedHaveGroup from "@/components/Social/group/haveGroup";
import FeedGroupSetting from "@/components/Social/group/groupSetting";
import FeedGroupList from "@/components/Social/group/groupList";
import FeedGroupUserblacklist from "@/components/Social/group/groupuserblacklist";
import FeedGroupAddAcc from "@/components/Social/group/groupAddAcc";
import FeedGroupAccList from "@/components/Social/group/groupAccList";
import FeedGroupBlackList from "@/components/Social/group/groupBlackList";
import FeedGroupDetail from "@/components/Social/group/groupDetail";

import AdminNotificationDetail from "@/components/AdminNotification/detail";
import AdminNotificationList from "@/components/AdminNotification/list";

import StatisticalChart from "@/components/StatisticalChart/index";
//影音
import VideoBase from "@/components/Video/VideoBase";

Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
const router = new Router({
  // routes: [
  //   {
  //     path: '*',
  //     component: maintain
  //   }
  // ],
  routes: [
    {
      path: "/Lives",
      name: "Lives",
      component: () => import("@/components/Livebroadcast/test"),
      meta: {
        title: "直播 - 尋寶網"
      }
    },
    {
      path: "/Home",
      component: Home,
      redirect: "/Index", //直接跳转到子组件
      children: [
        {
          path: "/Index",
          name: "Index",
          component: Index,
          meta: {
            title: "尋寶網 - 主頁",
            notificationInfo: {
              sgL_Type: "Index"
            }
          }
        },
        //#region 用户注册登录
        {
          path: "/customerLogin",
          name: "customerLogin",
          component: customerLogin,
          meta: {
            title: "登入 - 尋寶網"
          }
        },
        {
          path: "/Livebroadcast",
          name: "Livebroadcast",
          component: () => import("@/components/Livebroadcast/index"),
          meta: {
            title: "直播 - 尋寶網"
          }
        },
        {
          path: "/Live",
          name: "Live",
          component: () => import("@/components/Livebroadcast/index"),
          meta: {
            title: "直播 - 尋寶網"
          }
        },

        {
          path: "/blog",
          name: "blog",
          component: blogIndex,
          redirect: "/blog/all",
          meta: {
            title: "尋寶網"
          },
          children: [
            {
              path: "all",
              name: "blogAll",
              component: blogAll,
              meta: {
                notificationInfo: {
                  sgL_Type: "BLog"
                }
              }
            },
            {
              path: "category",
              name: "blogCategory",
              component: blogCategory
            },
            {
              path: "detail",
              name: "blogDetail",
              component: blogContent
            }
          ]
        },
        {
          path: "/blog/userInfo",
          name: "blogUserInfo",
          component: blogUserInfo
        },
        {
          path: "/forgotPassword",
          name: "forgotPassword",
          component: forgotPassword,
          meta: {
            title: "忘記密碼 - 尋寶網"
          }
        },
        {
          path: "/resetPassword",
          name: "resetPassword",
          component: resetPassword,
          meta: {
            title: "重置密碼 - 尋寶網"
          }
        },
        {
          path: "/resetPwSuccess",
          name: "resetPwSuccess",
          component: resetPwSuccess,
          meta: {
            title: "重置成功 - 尋寶網"
          }
        },
        {
          path: "/customerRegist",
          name: "customerRegist",
          component: customerRegist,
          meta: {
            title: "註冊 - 尋寶網"
          }
        },
        {
          path: "/registerEmail",
          name: "registerEmail",
          component: registerEmail,
          meta: {
            title: "註冊 - 尋寶網"
          }
        },
        {
          path: "/registerSuccess",
          name: "registerSuccess",
          component: registerSuccess,
          meta: {
            title: "註冊成功 - 尋寶網"
          }
        },
        {
          path: "/certification",
          name: "certification",
          component: certification,
          meta: {
            title: "認證 - 尋寶網"
          }
        },
        {
          path: "/certificationFlow",
          name: "certificationFlow",
          component: certificationFlow,
          meta: {
            title: "實名認證條款 - 尋寶網"
          }
        },
        {
          path: "/certificationTerms",
          name: "certificationTerms",
          component: certificationTerms,
          meta: {
            title: "實名認證條款 - 尋寶網"
          }
        },
        {
          path: "/customerPublish",
          name: "customerPublish",
          component: customerPublish,
          meta: {
            title: "我的發佈內容 - 尋寶網"
          }
        },
        {
          path: "/customerPrivateMessage",
          name: "customerPrivateMessage",
          component: customerPrivateMessage,
          meta: {
            title: "私訊 - 尋寶網"
          }
        },
        // {
        //   path: "/customerPublishLook",
        //   name: "customerPublishLook",
        //   component: customerPublishLook,
        //   meta: {
        //     title: "發佈內容 - 尋寶網"
        //   }
        // },
        {
          path: "/customerPublishLook",
          name: "customerPublishLook",
          component: () =>
            import("@/components/Customer/customerPublishLookcopy"),
          meta: {
            title: "發佈內容 - 尋寶網"
          }
        },
        {
          path: "/customerFavorite",
          name: "customerFavorite",
          component: customerFavorite,
          meta: {
            title: "我的收藏 - 尋寶網"
          }
        },
        {
          path: "/customerMessage",
          name: "customerMessage",
          component: customerMessage,
          meta: {
            title: "我的留言 - 尋寶網"
          }
        },
        {
          path: "/customerInfo",
          name: "customerInfo",
          component: customerInfo,
          meta: {
            title: "設定 - 尋寶網"
          }
        },
        //#endregion

        //#region 影音部分
        {
          path: "/video",
          name: "VideoIndex",
          component: VideoIndex,
          meta: {
            title: "影音 - 尋寶網",
            notificationInfo: {
              sgL_Type: "Moive"
            }
          }
        },

        {
          // path: "/videowatchOLD/:id/:itemtype", //参数
          // name: "WatchVideoOLD",
          path: "/videowatch/:id/:itemtype", //参数
          name: "WatchVideo",
          component: WatchVideo,
          meta: {
            title: "視頻播放 - 尋寶網",
            parentPath: "VideoIndex"
          }
        },

        // {
        //   path: "/search/:q?/:type?",
        //   component: search,
        //   name: "search",
        //   meta: {
        //     title: "搜索 - 尋寶網",
        //     parentPath: "VideoIndex"
        //   }
        // },
        {
          path: "/search/:q?/:type?",
          component: () => import("@/components/Video/search"),
          name: "search",
          meta: {
            title: "搜索 - 尋寶網",
            parentPath: "VideoIndex"
          }
        },
        {
          path: "/programme",
          component: MoreProgram,
          name: "MoreProgram",
          meta: {
            title: "我們的節目 - 尋寶網",
            parentPath: "VideoIndex"
          }
        },
        {
          path: "/videolist",
          component: MoreMovie,
          name: "Morevideo",
          meta: {
            title: "影片一覽 - 尋寶網",
            parentPath: "VideoIndex"
          }
        },
        // {
        //   path: '/feed', component: Feed, name: "feed",
        //   meta: {
        //     title: '社群動態 - 尋寶網',
        //     parentPath: 'Feed'
        //   }
        // },
        {
          path: "/feedHome",
          component: FeedHome,
          name: "FeedHome",
          meta: {
            title: "社群動態 - 尋寶網",
            parentPath: "Feed"
          },
          children: [
            {
              path: "/feedPointRecond",
              component: () => import("@/components/Social/point/pointRecond"),
              name: "pointRecond",
              meta: {
                title: "我的點數記錄 - 尋寶網"
              }
            },
            {
              path: "/feedfriend",
              name: "feedfriend",
              component: Feedfriend,
              redirect: {
                name: "feedGroup_groupAddAcc"
              },
              meta: {
                title: "社群動態 - 主頁"
              },
              children: [
                {
                  path: "groupAddAcc",
                  name: "feedGroup_groupAddAcc",
                  component: FeedGroupAddAcc,
                  meta: {
                    title: "添加好友/群 - 主頁"
                  }
                },
                {
                  path: "groupAccList",
                  name: "feedGroup_groupAccList",
                  component: FeedGroupAccList,
                  meta: {
                    title: "好友列表 - 主頁"
                  }
                },
                {
                  path: "groupBlackList",
                  name: "feedGroup_groupBlackList",
                  component: FeedGroupBlackList,
                  meta: {
                    title: "黑名單 - 主頁"
                  }
                }
              ]
            },
            {
              path: "/feedGroup",
              name: "feedGroup",
              component: FeedGroup,
              redirect: {
                name: "feedGroup_haveGroup"
              },
              meta: {
                title: "社群動態 - 主頁"
              },
              children: [
                {
                  path: "haveGroup",
                  name: "feedGroup_haveGroup",
                  component: FeedHaveGroup,
                  meta: {
                    title: "現有群組 - 主頁",
                    notificationInfo: {
                      sgL_Type: "Group"
                    }
                  }
                },

                {
                  path: "groupSetting",
                  name: "feedGroup_groupSetting",
                  component: FeedGroupSetting,
                  meta: {
                    title: "群組設置 - 主頁"
                  }
                },
                {
                  path: "groupList",
                  name: "feedGroup_groupList",
                  component: FeedGroupList,
                  meta: {
                    title: "群組列表 - 主頁"
                  }
                },
                {
                  path: "groupuserblacklist",
                  name: "feedGroup_userblacklist",
                  component: FeedGroupUserblacklist,
                  meta: {
                    title: "群組黑名單列表 - 主頁"
                  }
                }
              ]
            },
            {
              path: "feedGroupDetail",
              name: "feedGroup_FeedGroupDetail",
              component: FeedGroupDetail,
              meta: {
                title: "社群動態 - 主頁"
              }
            },
            {
              path: "/feed",
              name: "feed",
              component: Feed,
              meta: {
                title: "社群動態 - 主頁"
              }
            },
            {
              path: "/feed/MyDynamic",
              component: MyDynamic,
              name: "MyDynamic",
              meta: {
                title: "我的動態 - 尋寶網",
                customerNeedLogin: true
              }
            },

            {
              path: "/feed/MyDynamicPic",
              component: MyDynamicPic,
              name: "MyDynamicPic",
              meta: {
                title: "我的動態相片 - 尋寶網",
                customerNeedLogin: true
              }
            },
            {
              path: "/feed/FeedCloud",
              component: FeedCloud,
              name: "FeedCloud",
              meta: {
                title: "尋寶雲影片 - 尋寶網"
              }
            },
            {
              path: "/feed/FeedCloud/DisplayVideo",
              component: DisplayVideo,
              name: "DisplayVideo",
              meta: {
                title: "尋寶雲影片 - 尋寶網"
              }
            },
            {
              path: "/feed/FeedCloud/FeedPerson",
              component: FeedPerson,
              name: "FeedPerson",
              meta: {
                title: "尋寶雲影片 - 尋寶網"
              }
            }
          ]
        },
        {
          path: "/feed/SocialVideoUpload",
          component: SocialVideoUpload,
          name: "SocialVideoUpload",
          meta: {
            title: "上載影片 - 尋寶網",
            parentPath: "Feed"
          }
        },
        //#endregion
        //#region 話題部分
        {
          path: "/articleList",
          name: "articleList",
          component: articleList,
          meta: {
            title: "話題 - 尋寶網",
            notificationInfo: {
              sgL_Type: "NewArticle"
            }
          },
          beforeEnter: (to, from, next) => {
            if (to.fullPath == "/articleList") {
              next({
                path: "/articleList",
                query: { page: 1, size: 12, TypeId: 9999 }
              });
            } else {
              next();
            }
          }
        },
        {
          path: "/articleview",
          name: "articleview",
          component: articleview,
          meta: {
            title: "話題 - 尋寶網",
            parentPath: "articleList"
          }
        },
        //#endregion
        //#region
        {
          path: "/ActiveIndex/:id",
          name: "ActiveIndex",
          component: () => import("@/components/Activitys/index"),
          meta: {
            title: "活動名稱 - 尋寶網"
          }
        },

        {
          path: "/ActiveBase",
          name: "ActiveBase",
          component: () => import("@/components/Activitys/base"),
          meta: {
            title: "參加活動 - 尋寶網"
          },
          children: [
            {
              path: "/ActiveRegister/:id",
              name: "ActiveRegister",
              component: () => import("@/components/Activitys/register"),
              meta: {
                title: "報名表格 - 尋寶網"
              }
            },
            {
              path: "/ActiveSuccess/:id",
              name: "ActiveSuccess",
              component: () => import("@/components/Activitys/success"),
              meta: {
                title: "報名成功 - 尋寶網"
              }
            },
            {
              path: "/ActiveQASuccess/:id",
              name: "ActiveQASuccess",
              component: () => import("@/components/Activitys/successQA"),
              meta: {
                title: "答題成功 - 尋寶網"
              }
            },
            {
              path: "/ActiveRegisterQA/:id",
              name: "ActiveRegisterQA",
              component: () => import("@/components/Activitys/registerQA"),
              meta: {
                title: "問答活動 - 尋寶網"
              }
            },
            {
              path: "/ActiveDraw/:id",
              name: "ActiveDraw",
              component: () => import("@/components/Activitys/Draw"),
              meta: {
                title: "抽獎活動 - 尋寶網"
              }
            }
          ]
        },
        //#endregion

        //#region 賽程部分
        {
          path: "/eventList",
          name: "eventList",
          component: ActiveList,
          meta: {
            title: "賽程 - 尋寶網",
            notificationInfo: {
              sgL_Type: "Activity"
            }
          }
        },
        {
          path: "/eventview/:id",
          name: "eventview",
          component: Activeview,
          meta: {
            title: "賽程 - 尋寶網",
            parentPath: "ActiveList"
          }
        },
        {
          path: "/profileBookmarkEvent",
          name: "profileBookmarkEvent",
          component: Activeview,
          meta: {
            title: "收藏活動 - 尋寶網",
            parentPath: "profileBookmarkEvent"
          }
        },
        {
          path: "/sendmessage",
          name: "sendmessage",
          component: SendMessage,
          meta: {
            title: "提供活動資訊 - 尋寶網",
            parentPath: "ActiveList"
          }
        },
        //#endregion

        //#region 相册

        {
          path: "/uploadImage",
          name: "uploadImage",
          component: uploadImage,
          meta: {
            title: "上傳相片 - 尋寶網",
            customerNeedLogin: true
          }
        },
        {
          path: "/albumIndex",
          name: "albumIndex",
          component: albumIndex,
          meta: {
            title: "相簿 - 尋寶網",
            notificationInfo: {
              sgL_Type: "Photo"
            }
          }
        },
        {
          path: "/albumList",
          name: "albumList",
          component: albumList,
          meta: {
            title: "相簿 - 尋寶網"
          }
        },
        {
          path: "/albumviewDetail",
          name: "albumviewDetail",
          component: albumviewDetail,
          meta: {
            title: "相簿 - 尋寶網"
          }
        },
        {
          path: "/albumviewPhotostream",
          name: "albumviewPhotostream",
          component: albumviewPhotostream,
          meta: {
            title: "相簿 - 尋寶網"
          }
        },
        {
          path: "/albumviewPhoto",
          name: "albumviewPhoto",
          component: albumviewPhoto,
          meta: {
            title: "相簿 - 尋寶網"
          }
        },
        {
          path: "/albumviewFaceRecognition",
          name: "albumviewFaceRecognition",
          component: albumviewFaceRecognition,
          meta: {
            title: "相簿 - 尋寶網"
          }
        },
        {
          path: "/album/collection",
          name: "collection",
          component: collection,
          meta: {
            title: "收藏 - 尋寶網"
          }
        },
        {
          path: "/album/collectionlist",
          name: "collectionlist",
          component: collectionlist,
          meta: {
            title: "合集列表 - 尋寶網"
          }
        },
        {
          path: "/album/VRanking",
          name: "VRanking",
          component: VRanking,
          meta: {
            title: "攝影師排行 - 尋寶網"
          }
        },
        {
          path: "/photoview",
          name: "photoview",
          component: photoview,
          meta: {
            title: "查看圖片 - 尋寶網"
          }
        },

        //#endregion

        //#region footer
        {
          path: "/about",
          name: "about",
          component: about,
          meta: {
            title: "關於我們 - 尋寶網"
          }
        },
        {
          path: "/contact",
          name: "contact",
          component: contact,
          meta: {
            title: "聯絡我們 - 尋寶網"
          }
        },
        {
          path: "/service",
          name: "service",
          component: service,
          meta: {
            title: "服務條款 - 尋寶網"
          }
        },
        {
          path: "/privacy",
          name: "privacy",
          component: privacy,
          meta: {
            title: "隱私權保護政策 - 尋寶網"
          }
        },
        {
          path: "/copyright",
          name: "copyright",
          component: copyright,
          meta: {
            title: "尋寶網著作權保護政策 - 尋寶網"
          }
        },
        {
          path: "/advertise",
          name: "advertise",
          component: advertise,
          meta: {
            title: "廣告合作 - 尋寶網"
          }
        },
        {
          path: "/cooperate",
          name: "cooperate",
          component: cooperate,
          meta: {
            title: "商務合作 - 尋寶網"
          }
        },
        {
          path: "/comment",
          name: "comment",
          component: comment,
          meta: {
            title: "提出意見 - 尋寶網"
          }
        },
        {
          path: "/commentsucces",
          name: "commentsucces",
          component: commentsucces,
          meta: {
            title: "提出意見 - 尋寶網"
          }
        },
        {
          path: "/eventsucces",
          name: "eventsucces",
          component: eventsucces,
          meta: {
            title: "提出意見 - 尋寶網"
          }
        },
        {
          path: "/foot/:key",
          name: "initFoot",
          component: initFoot,
          meta: {
            title: " - 尋寶網"
          }
        }
        //#endregion
      ]
    },
    {
      path: "/certificationTermsIframe",
      name: "certificationTermsIframe",
      component: certificationTermsIframe,
      meta: {
        title: "實名認證條款 - 尋寶網"
      }
    },
    {
      path: "",
      component: Home,
      redirect: "/Index"
    },
    {
      path: "HomeVideo",
      component: () => import("../components/HomeVideo.vue"),
      redirect: "/videonew",
      children: [
        {
          path: "/VideoBase", //父级
          name: "VideoBase",
          redirect: "/videonew",
          component: VideoBase,
          children: [
            {
              path: "/videoindex",
              name: "VideoIndexN",
              component: () => import("@/components/Video/VideoIndexN"),
              props: true,
              meta: {
                title: "影音 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/videonew",
              name: "VideoIndexnew",
              component: () => import("@/components/Video/VideoIndexNew"),
              props: true,
              meta: {
                title: "影音 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/programme",
              name: "videoprogramme",
              component: () => import("@/components/Video/programme"),
              props: true,
              meta: {
                title: "獨家節目 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/mychannel",
              name: "mychannel",
              component: () => import("@/components/Video/MyChannel"),
              meta: {
                title: "你的頻道 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/ClassificationVideo",
              name: "ClassificationVideo",
              component: () => import("@/components/Video/ClassificationVideo"),
              meta: {
                title: "視頻分類 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/userchannel/:id",
              name: "userchannel",
              component: () => import("@/components/Video/userchannel"),
              meta: {
                title: "用戶訂閱 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/videolibrary",
              name: "videolibrary",
              component: () => import("@/components/Video/videolibrary"),
              meta: {
                title: "你的影片 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/favorite",
              name: "favorite",
              component: () => import("@/components/Video/favorite"),
              meta: {
                title: "收藏影片 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/history",
              name: "history",
              component: () => import("@/components/Video/history"),
              meta: {
                title: "觀看紀錄 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/video/subscription",
              name: "subscription",
              component: () => import("@/components/Video/subscription"),
              meta: {
                title: "訂閱列表 - 尋寶網",
                notificationInfo: {
                  sgL_Type: "Moive"
                }
              }
            },
            {
              path: "/WatchVideoBase", //参数
              name: "WatchVideoBase",
              component: () => import("@/components/Video/WatchVideoBase"),
              children: [
                {
                  // path: "/videowatch/:id/:itemtype", //参数
                  // name: "WatchVideo",
                  path: "/videowatchNEW/:id/:itemtype", //参数
                  name: "WatchVideoNEW",
                  component: () => import("@/components/Video/WatchVideoNew"),
                  meta: {
                    // title: "視頻播放 - 尋寶網"
                  }
                },
                {
                  path: "/watchshort/:id/", //参数
                  name: "watchshort",
                  component: () => import("@/components/Video/WatchShort"),
                  meta: {
                    title: "視頻播放 - 尋寶網"
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    //#region  管理员后台
    {
      path: "/login",
      name: "login",
      component: login,
      meta: { title: "登錄 - 尋寶網管理後臺登錄" }
    },
    //管理员后台
    {
      path: "/admin",
      name: "admin",
      component: Backstage,
      meta: {
        title: "登錄 - 尋寶網管理後臺",
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      children: [
        {
          path: "AdminNotificationList",
          name: "AdminNotificationList",
          component: AdminNotificationList,
          meta: {
            title: "通告列表 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "AdminNotificationDetail",
          name: "AdminNotificationDetail",
          component: AdminNotificationDetail,
          meta: {
            title: "通告詳情 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/foot/page/edit",
          name: "footContentEdit",
          component: adminchildFooterEdit,
          meta: {
            title: "頁面編輯 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/foot/parent",
          name: "footParent",
          component: adminParentFooter,
          meta: {
            title: "頁腳母層管理 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/foot/child",
          name: "footChild",
          component: adminchildFooter,
          meta: {
            title: "頁腳子層管理 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/foot/page",
          name: "footPage",
          component: adminpageFooter,
          meta: {
            title: "頁面管理 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/userLog",
          name: "userLog",
          component: userLog,
          meta: {
            title: "用戶操作日誌 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/adminLog",
          name: "adminLog",
          component: adminLog,
          meta: {
            title: "管理人員操作日誌 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/defaultIndex",
          name: "adminDefaultIndex",
          component: adminDefaultIndex,
          meta: {
            title: "首页 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/index",
          name: "adminIndex",
          component: adminIndex,
          meta: {
            title: "數據分析 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        //新增浏览量的组件 Pointindex PointManage SetPoint
        {
          path: "/admin/StatisticalChart",
          name: "StatisticalChart",
          component: StatisticalChart,
          meta: {
            title: "瀏覽 - 訪問量",
            requireAuth: true
          }
        },
        //#region AdminPoint 點數管理
        {
          path: "/admin/pointIndex",
          name: "pointIndex",
          component: () => import("@/components/AdminPoint/index"),
          meta: {
            title: "點數管理 - 點數數據表",
            requireAuth: true
          }
        },
        {
          path: "/admin/PointRecordList",
          name: "PointRecordList",
          component: () => import("@/components/AdminPoint/PointRecordList"),
          meta: {
            title: "點數管理 - 點數記錄列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/SetActivityMedal",
          name: "SetActivityMedal",
          component: () => import("@/components/AdminPoint/SetActivityMedal"),
          meta: {
            title: "點數管理 - 設置活動獎牌",
            requireAuth: true
          }
        },
        // {
        //   path: "/admin/setpointnew",
        //   name: "setpointnew",
        //   component: () => import("@/components/AdminPoint/setpointnew"),
        //   meta: {
        //     title: "點數管理 - 設置點數",
        //     requireAuth: true
        //   }
        // },
        {
          path: "/admin/MedalList",
          name: "MedalList",
          component: () => import("@/components/AdminPoint/MedalList"),
          meta: {
            title: "點數管理 - 獎牌名單列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/SetPoint",
          name: "setpoint",
          component: () => import("@/components/AdminPoint/SetPoint"),
          meta: {
            title: "點數管理 - 設置點數",
            requireAuth: true
          }
        },
        {
          path: "/admin/SystemActive",
          name: "SystemActive",
          component: () => import("@/components/AdminPoint/SystemActive"),
          meta: {
            title: "點數管理 - 活動頁系統列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/ListWinners/:id",
          name: "ListWinners",
          component: () => import("@/components/AdminPoint/ListWinners"),
          meta: {
            title: "點數管理 - 中獎名單列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/UserProfileList/:id/:fromid",
          name: "UserProfileList",
          component: () => import("@/components/AdminPoint/UserProfileList"),
          meta: {
            title: "點數管理 - 活動表格-參加用戶資料",
            requireAuth: true
          }
        },
        {
          path: "/admin/UserProfileList/:id/",
          name: "UserProfileList2",
          component: () => import("@/components/AdminPoint/UserProfileList2"),
          meta: {
            title: "點數管理 - 活動表格-參加用戶資料",
            requireAuth: true
          }
        },
        {
          path: "/admin/FromOption",
          name: "FromOption",
          component: () => import("@/components/AdminPoint/FromOption"),
          meta: {
            title: "點數管理 - 表格選項導入",
            requireAuth: true
          }
        },
        {
          path: "/admin/EditActivities/:id?",
          name: "EditActivities",
          component: () => import("@/components/AdminPoint/EditActivities"),
          meta: {
            title: "點數管理 - 活動頁系統列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/QAnswerList",
          name: "QAnswerList",
          component: () => import("@/components/AdminPoint/QAnswerList"),
          meta: {
            title: "點數管理 - 問答題目列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/RouletteList",
          name: "RouletteList",
          component: () => import("@/components/AdminPoint/RouletteList"),
          meta: {
            title: "點數管理 - 輪盤積分導入",
            requireAuth: true
          }
        },
        {
          path: "/admin/PrizeManagement",
          name: "PrizeManagement",
          component: () => import("@/components/AdminPoint/PrizeManagement"),
          meta: {
            title: "點數管理 - 獎品管理庫存導入",
            requireAuth: true
          }
        },
        {
          path: "/admin/RedemptionList",
          name: "RedemptionList",
          component: () => import("@/components/AdminPoint/RedemptionList"),
          meta: {
            title: "點數管理 - 積分獎品換領列表",
            requireAuth: true
          }
        },
        {
          path: "/admin/UserCreditList",
          name: "UserCreditList",
          component: () => import("@/components/AdminPoint/UserCreditList"),
          meta: {
            title: "點數管理 - 用戶積分列表",
            requireAuth: true
          }
        },
        //#endregion AdminPoint
        {
          path: "/admin/hangfire",
          name: "adminHangfire",
          component: adminHangfire,
          meta: {
            title: "hangfire - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/ad/AdVertiserList",
          name: "AdVertiserList",
          component: AdVertiserList,
          meta: {
            title: "廣告商管理 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/ad/AdList",
          name: "AdList",
          component: AdList,
          meta: {
            title: "廣告列表 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/video",
          name: "VideoList",
          component: VideoList,
          meta: {
            title: "一般影片 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/tv",
          name: "TVList",
          component: TVList,
          meta: {
            title: "Soonnet TV - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/video/feature",
          name: "FeatureList",
          component: FeatureList,
          meta: {
            title: "精選影片 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/program",
          name: "AdminProgramList",
          component: AdminProgramList,
          meta: {
            title: "節目列表 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        //#region  banner
        {
          path: "/admin/Banner",
          name: "banner",
          component: banner,
          meta: {
            title: "首頁橫額設定",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/CreateBanner",
          name: "CreateBanner",
          component: CreateBanner,
          meta: {
            title: "首頁橫額設定",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/adminSocia",
          name: "adminSocia",
          component: adminSocia,
          meta: {
            title: "動態列表",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/adminSociaGroup",
          name: "adminSociaGroup",
          component: adminSociaGroup,
          meta: {
            title: "動態列表",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/adminSociaCloseGroup",
          name: "adminSociaCloseGroup",
          component: adminSociaCloseGroup,
          meta: {
            title: "動態列表",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/adminVideoList",
          name: "adminVideoList",
          component: adminVideoList,
          meta: {
            title: "短視頻列表 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },

        //#endregion
        {
          path: "/admin/program/category ",
          name: "programType",
          component: programType,
          meta: {
            title: "節目類型 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/video/category ",
          name: "VideoType",
          component: VideoType,
          meta: {
            title: "影片類型 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/hotword",
          name: "HotWord",
          component: HotWord,
          meta: {
            title: "熱詞列表 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/video/upload",
          name: "uploadTV",
          component: uploadTV,
          meta: {
            title: "影片上傳 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/admin/program/edit/:Id?",
          name: "EditProgram",
          component: EditProgram,
          meta: {
            title: "節目編輯 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        //用戶權限路由
        {
          path: "/user/userList",
          name: "userList",
          component: userList,
          meta: {
            title: "用戶列表 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "/user/rolePermissions",
          name: "rolePermissions",
          component: rolePermissions,
          meta: {
            title: "角色權限配置 - 尋寶網管理後臺",
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "/user/roleList",
          name: "roleList",
          component: roleList,
          meta: {
            title: "角色列表 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "/user/roleMenuList",
          name: "roleMenuList",
          component: roleMenuList,
          meta: {
            title: "角色菜單列表 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        //活動路由
        {
          path: "Event/EventList",
          name: "EventList",
          component: EventList,
          meta: {
            title: "活動列表 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Event/EventType",
          name: "EventType",
          component: EventType,
          meta: {
            title: "活動類型 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Event/EventCity",
          name: "EventCity",
          component: EventCity,
          meta: {
            title: "舉辦城市 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Event/EventArea",
          name: "EventArea",
          component: EventArea,
          meta: {
            title: "舉辦地區 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Event/EventStatus",
          name: "EventStatus",
          component: EventStatus,
          meta: {
            title: "活動狀態 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Event/EventRemark",
          name: "EventRemark",
          component: EventRemark,
          meta: {
            title: "活動附注 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Event/EventAdd",
          name: "EventAdd",
          component: EventAdd,
          meta: {
            title: "活動添加 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        //話題路由
        {
          path: "/Topic/TopicList",
          name: "TopicList",
          component: TopicList,
          meta: {
            title: "文章列表 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "articleAdd",
          name: "articleAdd",
          component: articleAdd,
          meta: {
            title: "文章内容 - 尋寶網"
          }
        },
        {
          path: "Topic/TopicRecommend",
          name: "TopicRecommend",
          component: TopicRecommend,
          meta: {
            title: "編輯推薦 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Topic/TopicTypeList",
          name: "TopicTypeList",
          component: TopicTypeList,
          meta: {
            title: "文章類型 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Topic/TopicReprint",
          name: "TopicReprint",
          component: TopicReprint,
          meta: {
            title: "轉載來源 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "report/adminReport",
          name: "adminReport",
          component: adminReport,
          meta: {
            title: "檢舉內容 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "adminBlogIndex",
          name: "adminBlogIndex",
          component: adminBlogIndex,
          meta: {
            title: "網誌 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        //相簿
        {
          path: "Album/AdminalbumList",
          name: "AdminalbumList",
          component: AdminalbumList,
          meta: {
            title: "相簿列表 - 尋寶網管理後臺"
          }
        },
        {
          path: "Album/AdminImgDeal",
          name: "AdminImgDeal",
          component: AdminImgDeal,
          meta: {
            title: "相簿列表 - 尋寶網管理後臺"
          }
        },
        {
          path: "Album//albumCategory",
          name: "albumCategory",
          component: albumCategory,
          meta: {
            title: "相簿分類 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Album//AlbumFeature",
          name: "AlbumFeature",
          component: AlbumFeature,
          meta: {
            title: "相簿精選 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Admin/Collection",
          name: "AdminCollection",
          component: AdminCollection,
          meta: {
            title: "相簿合集列表 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Admin/AdminCollectionEdit",
          name: "AdminCollectionEdit",
          component: AdminCollectionEdit,
          meta: {
            title: "合集詳情 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        {
          path: "Album//PhotoFeature",
          name: "PhotoFeature",
          component: PhotoFeature,
          meta: {
            title: "精選相片 - 尋寶網管理後臺",
            requireAuth: true
          }
        },
        //留言
        {
          path: "AdminComment/comments",
          name: "comments",
          component: comments,
          meta: {
            title: "留言列表 - 尋寶網管理後臺"
          }
        }
      ]
    },
    //#endregion
    {
      path: "*",
      component: sortLink
    }
  ],
  mode: "history",
  linkExactActiveClass: "active" //路由選中、不然會失去選中效果
});
router.beforeEach((to, from, next) => {
  // console.log(to, from);
  if (to.name !== from.name && from != null && from.name != null)
    router["fromComponent"] = from.name;
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js